module.exports = __webpack_public_path__ + "static/media/reel-logo.cc3167f7.svg";